import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { addProduct } from "src/redux/gifts/actions";
import {
  getHasExpressDelivery,
  getIsGiftOffer,
} from "src/redux/gifts/selectors";
import Container from "src/react/layout/container";
import Button from "src/react/components/button";
import { color } from "src/styles/variables";
import ImageGallery from "src/react/components/image-gallery";
import getProductOfferDiscountedPrice from "../helpers/get-product-offer-discounted-price";

class GiftsProduct extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    addProduct: PropTypes.func.isRequired,
    hasExpressDelivery: PropTypes.bool.isRequired,
    quantity: PropTypes.number,
    isProductInBasket: PropTypes.bool,
    isGiftOffer: PropTypes.bool,
  };

  getProductPrice() {
    const { product, isGiftOffer } = this.props;
    return isGiftOffer ? (
      <Fragment>
        <Discount>£{product.price}</Discount>
        <span data-selector={`GiftsProduct-${product.id}-price`}>
          £{getProductOfferDiscountedPrice(product.price)}
        </span>
      </Fragment>
    ) : (
      <span data-selector={`GiftsProduct-${product.id}-price`}>
        £{product.price}
      </span>
    );
  }

  render() {
    const {
      product,
      isProductInBasket,
      hasExpressDelivery,
      addProduct,
    } = this.props;
    return (
      <Wrapper id={product.slug}>
        <Container>
          <Inner>
            <ImageWrapper>
              <ImageGallery images={product.images} />
            </ImageWrapper>
            <ContentWrapper>
              <Title>{product.name}</Title>
              {product.priceConfigurable == null && (
                <Price>
                  {this.getProductPrice()}
                  {!hasExpressDelivery && " + Free delivery"}
                </Price>
              )}
              <Description
                dangerouslySetInnerHTML={{ __html: product.description }}
              />
              <Button
                data-selector="GiftsProduct-button"
                variant={isProductInBasket ? "outlinePrimary" : "primary"}
                onClick={() => {
                  addProduct({ productId: product.id, options: {} });
                }}
              >
                {isProductInBasket ? "Add another" : "Add to basket"}
              </Button>
            </ContentWrapper>
          </Inner>
        </Container>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  hasExpressDelivery: getHasExpressDelivery(state),
  isGiftOffer: getIsGiftOffer(state),
});

const mapDispatchToProps = {
  addProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftsProduct);

const Discount = styled.span`
  position: relative;
  font-size: 16px;
  margin-right: 10px;
  :after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: ${color.red};
    left: 0;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const Wrapper = styled.div`
  padding: 40px 0;
  border-bottom: 1px solid ${color.midGrey};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  @media (min-width: 650px) {
    flex-direction: row;
    max-width: 100%;
  }
`;

const ImageWrapper = styled.div`
  user-select: none;
  margin-bottom: 20px;
  width: 100%;
  height: auto;
  min-height: 244px;
  & img {
    display: block;
    margin: auto;
  }
  @media (min-width: 375px) {
    min-height: 286px;
  }
  @media (min-width: 414px) {
    min-height: 315px;
  }
  @media (min-width: 500px) {
    min-height: 380px;
  }
  @media (min-width: 600px) {
    min-height: 400px;
  }
  @media (min-width: 650px) {
    flex-basis: 50%;
    margin-bottom: 0;
    margin-right: 40px;
  }
`;

const ContentWrapper = styled.div`
  @media (min-width: 650px) {
    flex-basis: 50%;
  }
`;

const Title = styled.h2`
  font-size: 27px;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Price = styled.h3`
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 400;
  padding-bottom: 20px;
`;

const Description = styled.div`
  margin-bottom: 40px;
  ul {
    list-style: initial;
    list-style-position: inside;
  }
`;
